<template>
  <div>
    <el-card body-style="padding: 0" v-if="report_date" v-loading="detailLoading">
      <div slot="header" class="card_header">
        <span>{{ report_date }}-{{ show_type }}</span>
        <el-input class="w-200px" v-model="search" size="mini" placeholder="搜尋"/>
      </div>
      <div class="button_container">
        <el-button-group>
          <el-button type="primary" icon="el-icon-s-order" @click="setShowType('所有')">所有
          </el-button>
          <el-button type="success" icon="el-icon-check" @click="setShowType('體溫正常')">體溫正常
          </el-button>
          <el-button type="warning" icon="el-icon-error" @click="setShowType('疑似發燒')">疑似發燒
          </el-button>
        </el-button-group>
      </div>
      <ezoom-table
          :data="detailData"
          :columns="detailColumns"
          :search="search">
        <template slot="buttons">
          <el-button v-if="isToday" @click.stop="openDialog({},'add')"
                     type="primary" size="small" icon="el-icon-plus">
            新增
          </el-button>
        </template>
        <el-table-column
            v-if="isToday"
            fixed="left"
            label="操作"
            width="120">
          <template slot-scope="scope">
            <el-button @click.stop="openDialog(scope.row,'update')" type="warning"
                       size="small" icon="el-icon-edit"/>
            <el-popconfirm title="確定要刪除此體溫資料嗎？"
                           @onConfirm="del(scope.row)"
                           @onCancel="()=>{}"
                           confirmButtonText="確定"
                           cancelButtonText="取消">
              <el-button @click.stop="" slot="reference" type="danger"
                         size="small" icon="el-icon-delete"/>
            </el-popconfirm>
          </template>
        </el-table-column>
        <el-table-column
            prop="label"
            label="標籤"
            sortable
            width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.label === '體溫正常' ? 'success' : 'warning'"
                    disable-transitions>
              {{ scope.row.label }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="department" sortable label="部門" width="110"/>
        <el-table-column prop="employee_id" sortable label="員工編號" width="110"/>
        <el-table-column prop="user_name" sortable label="姓名" width="100"/>
        <el-table-column prop="temperature" sortable label="體溫" width="100"/>
        <el-table-column prop="date" sortable label="回報日期" width="120"/>
        <el-table-column prop="time" sortable label="回報時間" width="110"/>
        <el-table-column prop="has_symptom_str" sortable label="是否身體不適" width="150"/>
        <el-table-column prop="has_go_hospital_str" sortable label="是否已就醫" width="150"/>
        <el-table-column prop="is_covid_related_str" sortable label="與 COVID-19 有關" width="180"/>
        <el-table-column prop="info" sortable label="症狀說明" width="180"/>
      </ezoom-table>
    </el-card>
    <el-card v-else v-loading="detailLoading">
      請選擇左方任一筆統計資料 , 查看詳細內容
    </el-card>
    <crud-temperature
        ref="crudDialog"
        :add-fn="add"
        :update-fn="update"
        :employees="employees"/>
  </div>
</template>

<script>
import {ref, computed} from "@vue/composition-api";
import EzoomTable from "@/components/EzoomTable";
import CrudTemperature from "./CrudTemperature.vue";
import DateUtil from "@/utils/dateUtil";
import MessageService from "@/components/Message";
import LoadingService from "@/components/Loading";
import TemperatureService from "@/api/temperature";
import EmployeeService from "@/api/employee";

const data = ref([]);
const employees = ref([]);
const all_emps = ref([]);
const show_type = ref(null);
const dateRef = ref(null);
const departmentRef = ref(null);
const detailLoading = ref(false);
const Transformer = (array = [], fever_temperature) => {
  return array.map(single => {

    const getInfo = ({value, has_symptom, has_go_hospital, is_covid_related}) => {

      if ( 33 < parseFloat(value) && parseFloat(value) < 37.5 ) return '';
      else if (!has_symptom) return '近期注射covid-19疫苗';
      else if (has_symptom && !has_go_hospital) return '身體不適,未就醫';
      else if (has_symptom && has_go_hospital && !is_covid_related) return '身體不適,已就醫,covid-19無關';
      else if (has_symptom && has_go_hospital && is_covid_related) return '身體不適,已就醫,疑似covid-19有關';
    };

    return {
      ...single,
      user_id: single.employee_id,
      temperature: single.value && parseFloat(single.value),
      has_symptom: single.has_symptom,
      has_symptom_str: single.has_symptom ? "是" : "否",
      has_go_hospital_str: single.has_go_hospital ? "是" : "否",
      is_covid_related_str: single.is_covid_related ? "是" : "否",
      symptom_text: single.symptom_text,
      label: single.value && (parseFloat(single.value) >= fever_temperature ? "疑似發燒" : "體溫正常"),
      create_at: single.create_at,
      create_time: DateUtil.format(single.create_at, "YYYY / MM / DD - HH:mm:ss"),
      date: DateUtil.format(single.create_at, "YYYY / MM / DD "),
      time: DateUtil.format(single.create_at, "HH:mm:ss"),
      info: getInfo(single),
      employee_id: single.employee_id,
      user_name: single.employee_name,
      department: single.department
    };
  });
};
export const getDetailData = async ({date, department}) => {

  try {

    // loading start
    detailLoading.value = true;

    const temperatures = await TemperatureService.reportedTemperatureWithDept({date, department});
    data.value = Transformer(temperatures, 37.5);
    employees.value = await TemperatureService.getUnReports({date, department});
    all_emps.value = await EmployeeService.list(department);
    show_type.value = '所有';
    dateRef.value = date;
    departmentRef.value = department;

    // loading end
    detailLoading.value = false;

    return data.value;

  } catch (e) {

    detailLoading.value = false;
    throw e;
  }
}

export default {
  name: "Detail",
  components: {
    'ezoom-table': EzoomTable,
    'crud-temperature': CrudTemperature,
  },
  setup() {

    const search = ref('');

    const temperature = ref(null);
    const crudDialog = ref(null);

    const detailColumns = ref([
      {label: "標籤", prop: "label"},
      {label: "部門", prop: "department"},
      {label: "員工編號", prop: "employee_id"},
      {label: "姓名", prop: "user_name"},
      {label: "體溫", prop: "temperature"},
      {label: "回報日期", prop: "date"},
      {label: "回報時間", prop: "time"},
      {label: "是否身體不適", prop: "has_symptom_str"},
      {label: "是否有就醫", prop: "has_go_hospital_str"},
      {label: "與 COVID-19 有關", prop: "is_covid_related_str"},
      {label: "症狀說明", prop: "info"},
    ]);

    const setShowType = newShowType => show_type.value = newShowType;

    const isToday = computed(() => DateUtil.isSameDay(dateRef.value, new Date()));
    const report_date = computed(() => {

      const getReportDate = date => `${DateUtil.format(date, "YYYY/MM/DD")}(${DateUtil.getWeekDayStr(date)})`;
      return dateRef.value && getReportDate(dateRef.value);
    });

    const tableData = computed(() => data.value);

    const detailData = computed(() => {

      if (show_type.value === "所有") return tableData.value;
      else return tableData.value.filter(single => single.label === show_type.value);
    });

    const openDialog = (...args) => crudDialog.value.openDialog(...args)

    return {
      search,
      temperature,
      detailLoading,
      detailColumns,
      isToday,
      report_date,
      show_type,
      tableData,
      employees,
      detailData,
      crudDialog,
      setShowType,
      openDialog,
    };
  },
  methods: {

    // add . update . delete => getDetailData to fetch the new data
    async add(temperature) {

      // open the global loading mask
      LoadingService.open('新增體溫回報資料中...');

      const newTemperature = {
        lineId: temperature.line_id,
        employeeId: temperature.employee_id,
        temperature: temperature.value,
        hasSymptom: temperature.has_symptom,
        symptomText: temperature.symptom_text,
      }

      try {

        await TemperatureService.add(newTemperature);
        await getDetailData({date: dateRef.value, department: departmentRef.value});
        MessageService.success(`體溫資料，成功新增： *員編* ${temperature.employee_id} - *體溫* ${temperature.value}`);

      } catch (e) {

        MessageService.error(`錯誤提示：${e.title} , ${e.message}`);

      } finally {

        LoadingService.close();
      }
    },
    async update(temperature) {

      // open the global loading mask
      LoadingService.open('更新體溫回報資料中...');

      try {

        await TemperatureService.update(temperature.id, temperature);
        await getDetailData({date: dateRef.value, department: departmentRef.value});
        MessageService.success(`體溫資料，成功修改： *員編* ${temperature.employee_id} - *體溫* ${temperature.value}`);

      } catch (e) {

        MessageService.error(`錯誤提示：${e.title} , ${e.message}`);

      } finally {

        LoadingService.close();
      }
    },

    del(temperature) {

      TemperatureService.deleteById(temperature.id)
          .then(() => getDetailData({date: dateRef.value, department: departmentRef.value}))
          .then(() => MessageService.success(`體溫資料，成功刪除： *員編* ${temperature.employee_id} - *體溫* ${temperature.value}`))
          .catch(e => MessageService.error(`錯誤提示：${e.title} , ${e.message}`));
    },
  },
}
</script>

<style scoped>
</style>
